export const CHANGE_AD_UNIT_PATH = 'CHANGE_AD_UNIT_PATH'

export const AD_SIZES = {
  BANNER_1: [728, 90],
  BANNER_2: [320, 50],
  RAIL_1: [160, 600],
  RAIL_2: [300, 250],
  RAIL_3: [300, 600],
}
